import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import keys from './keys';
import useApiQuery from '../useApiQuery';

const useGetEpisode = ({ showId: showIdParam, episodeId: episodeIdParam, disabled } = {}) => {
  const { showId: currentShowId, episodeId: currentEpisodeId } = useParams();
  const showId = showIdParam || currentShowId;
  const episodeId = episodeIdParam || currentEpisodeId;

  const query = useApiQuery({
    requestUrl: `/shows/${showId}/episodes/${episodeId}`,
    disabled: !showId || !episodeId || disabled,
    queryKey: keys(showId).episode(episodeId),
  });

  return {
    episode: query.data,
    episodeError: query.error,
    isEpisodeFetchError: query.isError,
    isEpisodeFetchSuccess: query.isSuccess,
    isEpisodeFetching: query.isFetching,
    isEpisodeLoading: query.isInitialLoading,
    ...query,
  };
};

useGetEpisode.propTypes = {
  showId: PropTypes.string,
  episodeId: PropTypes.string,
  disabled: PropTypes.bool,
};

export default useGetEpisode;
